export const listingParams = [
    "listingId", "listingRequestType", "unmatchedListing", "exclusiveContent",
    "listingUniqueId", "listingIdBranch", "listingIdAgent","listingRequestType",
    "listingStreetAddress"
];

export const removeListingParams = () => {
    for (const listingParam of listingParams){
        sessionStorage.removeItem(listingParam);
    }
};